import { useRef, useEffect, useCallback, useState } from "react";
import { createHeader, createProductRow } from "@utils/utils";
import ProductsUI from "./ProductsUI";
import { productService } from "@services/ProductService";
import { ITableRow, IDataPage } from "../../../types/global";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
const Products = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<ITableRow[]>([]);
  const [products, setProducts] = useState<IDataPage>({});
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [search, setSearch] = useState("");
  const debouncedSearch = useRef(debounce(value => setSearch(value), 800)).current;
  const rowsPerPage = 6;
  const getAllProducts = useCallback(async (skipPage = 0, localSearch = "") => {
    try {
      setIsLoading(true);
      const res = await productService.getAll(rowsPerPage, skipPage * rowsPerPage, localSearch);
      setPages(Math.ceil(res.data.totalCount / rowsPerPage));
      setProducts(prod => ({
        ...prod,
        [skipPage + 1]: {
          search: localSearch,
          items: [...res.data.items.map(product => {
            return createProductRow(product.id, product.description, product.reference, product.price, product.status);
          })]
        }
      }));
    } catch (error) {
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [search]);
  useEffect(() => {
    setRows([]);
    const data = products[currentPage];
    if (data && data.search === search) {
      setRows(data.items);
    } else {
      getAllProducts(currentPage - 1, search);
    }
  }, [products, getAllProducts, currentPage, search]);
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  const headers = [createHeader("Nombre", "name"), createHeader("Referencia", "reference"), createHeader("Precio", "priceRender"), createHeader("Estado", "statusRender"), createHeader("Acciones", "actions")];
  return <ProductsUI isLoading={isLoading} showError={showError} closeError={() => setShowError(false)} errorMessage="Hubo problemas para consultar" headers={headers} rows={rows} onClick={() => navigate("/productos/crear")} pages={pages} currentPage={currentPage} onChangePage={setCurrentPage} onSearch={(value: string) => debouncedSearch(value)} onSearchClick={() => getAllProducts(currentPage - 1, search)} />;
};
export default Products;